var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-center"},[_vm._v("Customer Age Group Report")]),_c('CreateAgeGroupReport',{on:{"created":_vm.onCreated}}),_c('ListAgeGroupReport',{ref:"list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }